import {
  GroupType,
  MarkupAmountType,
  TaxAmountType,
} from 'graphql-query-contracts';
import { AdminFeeAmountType } from 'application-types';

import {
  ProductType,
  TaxPolicy,
  TaxDetails,
  TransactionPaidStatus,
} from './types';

type TransactionPaidStatusMapType = {
  [key: string]: TransactionPaidStatus;
};

export const TransactionPaidStatusMap = {
  SUCCEEDED: TransactionPaidStatus.SUCCESS,
  REFUND_SUCCEEDED: TransactionPaidStatus.REFUNDED,
  FAILED: TransactionPaidStatus.FAILURE,
} as TransactionPaidStatusMapType;

export const TAX_VALUE_CONVERSION = 100;

export const TAX_TYPE_OPTIONS = [
  {
    label: 'abp.billingAndPaymentSettings.tax.percentage',
    value: TaxAmountType.TaxAmountTypePercentage,
  },
  {
    label: 'abp.billingAndPaymentSettings.tax.fixed',
    value: TaxAmountType.TaxAmountTypeFixed,
  },
];

export const CREDIT_CATEGORY_NAME = 'Credit Bundles';
export const CREDIT_CATEGORY_DESCRIPTION = 'Category for credit bundles.';

export const DEFAULT_TAX_DETAILS = {
  taxName: 'Tax',
  taxAmountType: TaxAmountType.TaxAmountTypePercentage,
  taxAmountValue: 0,
  businessTaxName: '',
  businessTaxNumber: '',
  taxDisplayName: '',
  taxNumber: '',
  taxPolicy: TaxPolicy.EXCLUSIVE,
} as TaxDetails;

export const EMPTY_CATEGORY_DETAILS = {
  productCategoryId: '',
  name: '',
  description: '',
  groupId: '',
  groupType: GroupType.GroupTypeActivateChannel,
  productType: '' as ProductType,
};

export const EMPTY_PRODUCT_DETAILS = {
  productId: '',
  productGroupId: '',
  name: '',
  description: '',
  rate: '',
  markup: {
    type: MarkupAmountType.MarkupAmountTypePercentage,
    value: '',
  },
  adminFee: {
    type: AdminFeeAmountType.AdminFeeAmountTypePercentage,
    value: '',
  },
  tax: {
    type: TaxAmountType.TaxAmountTypePercentage,
    value: '',
  },

  productCategoryId: '',
  productCategoryName: '',
  productCategoryType: '' as ProductType,

  netPrice: '',
  quantity: '1',
  total: '',

  originalPrice: undefined,
  creditAmount: undefined,

  chargeCode: '',
  chargeCodeId: '',

  receivables: [],
};
